class PropertyGroupSaveController {

    constructor($rootScope, $state) {
        this.$state = $state;
        this.$rootScope = $rootScope;
    }
    
    $onInit() {
        this.activeTab = 'profile';
        this.propertyGroup = this.propertyGroup || {
            group_properties: []
        };
    }
}

PropertyGroupSaveController.$inject = [ '$rootScope', '$state' ];

export default PropertyGroupSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.group.save.controller.js